module.exports = {

	truncate(text, length, clamp){
		/*The function takes three parameters.
		"text" is the text to be truncated.
		"length" specifies the mazimum length of the trucated text
		"clamp" is the string to be attached at the end of the truncated text in case "length" is exceeded.
		Its default value is the string "..."*/
		clamp = clamp || '...';

		/*We create a div element and pass in text as its content. 
		This gets rid of tags and such, circumventing possible issues*/
		var node = document.createElement('div');
		node.innerHTML = text;

		/* We extract the text and assign it to the content variable.
		If the length of content is not greater than the specified length, the original text is returned.
		If not, we use the slice method to extract from the 0th character to the length-th character and append the clamp text.*/
		var content = node.textContent;
		return content.length > length ? content.slice(0, length) + clamp : content;
	}

};
